import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import { IconAfter, IconBefore, InputContainer, PrimaryInput } from './styles';

// function InputText({ label, onPressEnter, IconAfterProp, ...rest }, ref) {
const InputText = forwardRef(({ label, onPressEnter, IconAfterProp, IconBeforeProp, ...rest }, ref) => (
  // const [form] = Form.useForm();

  // const profile = useSelector(state => state.user.profile);

  // <Link to="/locationList?location=">linklink</Link>

  // function onSearch(value, event) {
  //   if (event.key === 'Enter') {
  //     console.log('Enter key pressed');
  //     console.log(value, event);
  //   }
  // }

  <InputContainer>
    {label && <label htmlFor={rest.id || 'input-text'}>{label}</label>}
    {/* <IconBefore /> */}
    <IconBefore>{IconBeforeProp}</IconBefore>
    <PrimaryInput
      {...rest}
      ref={ref}
      $hasIconAfter={Boolean(IconAfterProp)}
      $hasIconBefore={Boolean(IconBeforeProp)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && onPressEnter) {
          onPressEnter(e.currentTarget.value);
        }
      }}
    />
    <IconAfter $visible={Boolean(IconAfterProp)}>{IconAfterProp}</IconAfter>
  </InputContainer>
));

InputText.displayName = 'InputText';

InputText.propTypes = {
  // columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  // data: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string,
  onPressEnter: PropTypes.func,
  IconAfterProp: PropTypes.element,
  IconBeforeProp: PropTypes.element,
};

InputText.defaultProps = {
  label: '',
  onPressEnter: () => {},
  IconAfterProp: null,
  IconBeforeProp: null,
};

export default InputText;
